export function buildAfterFixLineSet(commentsArr) {
  const set = new Set();
  if (!Array.isArray(commentsArr) || commentsArr.length === 0) return set;
  const byThread = new Map();
  for (const c of commentsArr) {
    const tid = (c && (c.thread_id ?? c.threadId ?? c.ThreadID)) || 0;
    if (!byThread.has(tid)) byThread.set(tid, []);
    byThread.get(tid).push(c);
  }
  const extractAfterFixLines = (body) => {
    const linesOut = [];
    if (!body || typeof body !== 'string') return linesOut;
    const low = body.toLowerCase();
    const idx = low.indexOf('after fix');
    if (idx === -1) return linesOut;
    const tail = body.slice(idx);
    const match = tail.match(/```[a-zA-Z0-9]*\n([\s\S]*?)```/);
    if (match && match[1]) {
      const block = match[1];
      const lines = block.split('\n');
      for (const l of lines) {
        let t = l.replace(/\r/g, '').trim();
        if (t.length > 0 && (t[0] === '+' || t[0] === '-' || t[0] === ' ' || t[0] === '\t')) { t = t.slice(1).trim(); }
        if (t) linesOut.push(t);
      }
    } else {
      const tailLines = tail.split('\n');
      for (let i = 1; i < tailLines.length; i++) {
        let t = tailLines[i].replace(/\r/g, '').trim();
        if (t.toLowerCase().startsWith('**recommendation') || t.toLowerCase().startsWith('**how to fix') || t.toLowerCase().startsWith('**comments') || t.toLowerCase().startsWith('**problematic') || t.startsWith('**')) break;
        if (t === '') break;
        if (t.length > 0 && (t[0] === '+' || t[0] === '-' || t[0] === ' ' || t[0] === '\t')) { t = t.slice(1).trim(); }
        if (t) linesOut.push(t);
      }
    }
    return linesOut;
  };
  byThread.forEach((threadComments) => {
    const hasFixedReply = threadComments.some((c) => (c.body || '').toString().toLowerCase().includes('fixed - '));
    if (!hasFixedReply) return;
    for (const c of threadComments) {
      const body = (c.body || '').toString();
      const lines = extractAfterFixLines(body);
      for (const t of lines) set.add(t);
    }
  });
  return set;
}

export function buildIntentionalLineSet(comments) {
  const set = new Set();
  const extractIntentionalLines = (body) => {
    const linesOut = [];
    if (!body || typeof body !== 'string') return linesOut;
    const low = body.toLowerCase();
    let idx = -1;
    for (const key of ['problematic', 'original code', 'before fix', 'issue snippet']) {
      const i = low.indexOf(key);
      if (i !== -1) { idx = i; break; }
    }
    const tail = idx !== -1 ? body.slice(idx) : body;
    const match = tail.match(/```[a-zA-Z0-9]*\n([\s\S]*?)```/);
    if (match && match[1]) {
      const block = match[1];
      const lines = block.split('\n');
      for (const l of lines) {
        let t = l.replace(/\r/g, '').trim();
        if (t.length > 0 && (t[0] === '+' || t[0] === '-' || t[0] === ' ' || t[0] === '\t')) { t = t.slice(1).trim(); }
        if (t) { set.add(t); set.add(t.replace(/\s+/g, ' ').trim()); }
      }
    }
    return linesOut;
  };
  (comments || []).forEach(c => {
    const body = (c.body || '').toString();
    if (!body.toLowerCase().includes('marked intentional - ')) return;
    const lines = extractIntentionalLines(body);
    for (const t of lines) { set.add(t); set.add(t.replace(/\s+/g, ' ').trim()); }
  });
  return set;
}




